import { render, staticRenderFns } from "./BookingListBottom.vue?vue&type=template&id=47dc2eaa&scoped=true"
import script from "./BookingListBottom.vue?vue&type=script&lang=js"
export * from "./BookingListBottom.vue?vue&type=script&lang=js"
import style0 from "./BookingListBottom.vue?vue&type=style&index=0&id=47dc2eaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc2eaa",
  null
  
)

export default component.exports